var LoadingDialogComponent = /** @class */ (function () {
    function LoadingDialogComponent(data) {
        this.data = data;
    }
    return LoadingDialogComponent;
}());
export { LoadingDialogComponent };
